import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import Constants from '../../../definitions/constants';
import LocaleTooling from '../../../tooling/localeTooling';
import InterfaceTooling from '../../../tooling/interfaceTooling';

import Select from '../common/inputs/select';
import FetchAutocompleteList from '../common/inputs/fetchAutocompleteList';

const CalculationUnitsFilter = props => {
  const {
    onChangeFilter,
    filterValues,
    connectorType,
    selectedPeriod,
    groupsData,
    calculationUnitsData,
    calculationUnitsFetchAction,
    calculationUnitsLoading,
    modelsData
  } = props;
  let periodState = selectedPeriod ? selectedPeriod.state : ""; 
  return (
    <div className="calculation_units_filter_wrapper">
      <label className="calculation_units_filter_label">
        {LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="endpointsConnectorsPanel.calculationUnitsFilterLabel"/>)}
      </label>
      <Select 
        value={filterValues["filterGroup"]}
        onChange={onChangeFilter}
        labelLocale={<FormattedMessage id="periodAdmin.calculationUnitFilterGroupsLabel"/>}
        options={InterfaceTooling.getSelectArrayFromArrayOfObjects(groupsData, "id", "name")}
        data-path="filterGroup"
      />
      <Select 
        value={filterValues["criteria"]}
        onChange={onChangeFilter}
        labelLocale={<FormattedMessage id="periodAdmin.calculationUnitFilterLabel"/>}
        options={InterfaceTooling.getSelectArray("calculationFilters.calculationUnitFilter", "periodAdmin.calculationUnitFilter", false)}
        data-path="criteria"
      />
      {(filterValues["criteria"]!="" && filterValues["criteria"]!=Constants.calculationFilters.calculationUnitFilter.ALL) && (
        <FetchAutocompleteList        
          values={filterValues["calculationUnitsSelected"]}
          onChange={onChangeFilter}
          addSelectLocale={LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id:"periodAdmin.calculationUnitFilterFinderLabel"}))}
          options={InterfaceTooling.getSelectArrayFromArrayOfObjects(calculationUnitsData, "id", "name", false)}
          valueAccesor={"id"}
          labelAccesor={"name"}
          fetchListAction={calculationUnitsFetchAction}
          loadingFetch={calculationUnitsLoading}
          data-path="calculationUnitsSelected"
        />
      )}
      {(connectorType == Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_calculations_endpoint_type ||
        (connectorType == Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_reports_endpoint_type && periodState == "reprocess")
      ) && (
        <label className="calculation_units_filter_label">
          {LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="endpointsConnectorsPanel.otherFiltersLabel"/>)}
        </label>
      )}
      {(connectorType == Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_calculations_endpoint_type) && (
        <Select 
          value={filterValues["polynomial_id"]}
          onChange={onChangeFilter}
          labelLocale={<FormattedMessage id="periodAdmin.calculationUnitFilterModelsLabel"/>}
          options={InterfaceTooling.getSelectArrayFromArrayOfObjects(modelsData, "id", "name")}
          data-path="polynomial_id"
        />
      )}
      {((connectorType == Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_reports_endpoint_type ||
        connectorType == Constants.selectKeys.endpoint.endpoint_connector_type.output_export_calculation_units_calculations_endpoint_type) &&
        periodState == "reprocess"
      ) && (
        <Select 
          value={filterValues["reprocess_criteria"]}
          onChange={onChangeFilter}
          labelLocale={<FormattedMessage id="endpointsConnectorsPanel.reprocessCriteriaFilter"/>}
          options={InterfaceTooling.getSelectArray("selectKeys.endpoint.reprocess_criteria", "endpointsConnectorsPanel.reprocessCriteriaFilterOptions", false)}
          data-path="reprocess_criteria"
        />        
      )}
    </div>
  );
};

export default CalculationUnitsFilter;



// WEBPACK FOOTER //
// ./source/client/components/endpointsConnectorsPanel/calculationUnitsFilter.jsx